import { FormattedMessage } from 'dibs-react-intl';

export const recognizedTitle = (
    <FormattedMessage
        id="PdpSharedDealerDistinctions.recognizedTitle"
        key="recognizedTitle"
        defaultMessage="Recognized"
    />
);

export const recognizedDescription = (
    <FormattedMessage
        key="recognizedDescription"
        id="PdpSharedDealerDistinctions.recognizedDescription"
        defaultMessage="These prestigious sellers are industry leaders and represent the highest echelon for item quality and design."
    />
);

export const vettedTitle = (
    <FormattedMessage
        id="PdpSharedDealerDistinctions.vettedTitle"
        key="vettedTitle"
        defaultMessage="Vetted"
    />
);

export const vettedDescription = (
    <FormattedMessage
        id="PdpSharedDealerDistinctions.vettedDescription"
        defaultMessage="These experienced sellers undergo a comprehensive evaluation by our team of in-house experts."
    />
);

export const goldSellerTitle = (
    <FormattedMessage
        key="goldSellerTitle"
        id="PdpSharedDealerDistinctions.goldSellerTitle"
        defaultMessage="Gold"
    />
);

export const goldSellerDescription = (
    <FormattedMessage
        id="PdpSharedDealerDistinctions.goldSellerDescription"
        defaultMessage="These expertly vetted sellers are highly rated and consistently exceed customer expectations."
    />
);

export const platinumSellerTitle = (
    <FormattedMessage
        id="PdpSharedDealerDistinctions.platinumSellerTitle"
        key="platinumSellerTitle"
        defaultMessage="Platinum"
    />
);

export const tieredSellerDescription = (
    <FormattedMessage
        id="PdpSharedDealerDistinctions.tieredSellerDescription"
        defaultMessage="These expertly vetted sellers are 1stDibs' most experienced sellers and are rated highest by our customers."
    />
);

export const diamondSellerTitle = (
    <FormattedMessage
        id="PdpSharedDealerDistinctions.diamondSellerTitle"
        key="diamondSellerTitle"
        defaultMessage="Diamond"
    />
);

export const associationsTitle = (
    <FormattedMessage
        key="associationsTitle"
        id="PdpSharedDealerDistinctions.associationsTitle"
        defaultMessage="Associations"
    />
);

export const associationsDescription = (
    <FormattedMessage
        key="associationsDescription"
        id="PdpSharedDealerDistinctions.associationsDescription"
        defaultMessage="This seller is a vetted member of professional associations."
    />
);

export const recognizedSeller = (
    <FormattedMessage
        id="PdpSharedDealerDistinctions.recognizedSeller"
        defaultMessage="Recognized Seller"
    />
);

export const vettedSeller = (
    <FormattedMessage
        id="PdpSharedDealerDistinctions.vettedSeller"
        defaultMessage="Vetted Seller"
    />
);

export const goldSeller = (
    <FormattedMessage id="PdpSharedDealerDistinctions.goldSeller" defaultMessage="Gold Seller" />
);

export const platinumSeller = (
    <FormattedMessage
        id="PdpSharedDealerDistinctions.platinumSeller"
        defaultMessage="Platinum Seller"
    />
);

export const diamondSeller = (
    <FormattedMessage
        id="PdpSharedDealerDistinctions.diamondSeller"
        defaultMessage="Diamond Seller"
    />
);
